import { WriteTransaction } from 'replicache'
import { ActivityEvent, eventBaseOps } from '@basehub/data/replicache/index'

async function createEvent(
  tx: WriteTransaction,
  { event }: { event: ActivityEvent }
): Promise<void> {
  await eventBaseOps.put(tx, event)
}

export const eventMutators = {
  createEvent,
  listEvents: eventBaseOps.list,
  deleteEvent: eventBaseOps.delete,
}
